import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { nest, branch, compose, renderComponent } from 'recompose'

import AEDetailsSpec from 'containers/Project/AEDetailsSpec/index'
import AEDetailsEdit from './AEDetailsEdit'
import ModuleHeaderContainer from 'components/project/ModuleHeaderContainer/index'

import styles from './styles.scss'

const AEDetailsSpecStyled = (props) => {
  const {
    aeDetails
  } = props;

  if (Object.keys(aeDetails).length === 0) return;

  return (
    <div styleName='ae_details'>
      <AEDetailsSpec
        moduleData={ aeDetails }
        ModuleHeader={nest(ModuleHeaderContainer,
        () => <span></span>,
        )}
      />
    </div>
  );
}

const withBranch = branch(({edit}) => edit, renderComponent(AEDetailsEdit))
const withStyle = CSSModules(styles)

const enhance = compose(
  withBranch,
  withStyle
)

export default enhance(AEDetailsSpecStyled)